import { useReducer } from 'react'

import effects from 'app/effects/effects'
import MessageAlert from 'app/components/MessageAlert'
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'

import { DELIVER, READ, REACTION, TTS } from 'app/constants/messageDetail'

export const ActionType = {
  SET_LOADING: 'SET_LOADING',
  SET_VIEW_METRICS: 'SET_VIEW_METRICS',
  SET_DELIVER_METRICS: 'SET_DELIVER_METRICS',
  SET_USER_REACTION_METRICS: 'SET_USER_REACTION_METRICS',
  SET_TEXT_TO_SPEECH_METRICS: 'SET_TEXT_TO_SPEECH_METRICS',
}

const initialState = {
  deliverMetrics: {
    app: null,
    sms: null,
    email: null,
    automated: null,
  },
  viewMetrics: { read: [], feedRead: [], didntRead: [] },
  userReactionMetrics: {
    likes: {
      liked: [],
      didntLike: [],
    },
    reports: {
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
    },
  },
  textToSpeechMetrics: {
    fullListened: [],
    listened: [],
  },
  isLoading: true,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.SET_LOADING:
      return {
        ...state,
        isLoading: action.value,
      }
    case ActionType.SET_DELIVER_METRICS:
      return {
        ...state,
        deliverMetrics: action.value,
        isLoading: false,
      }
    case ActionType.SET_VIEW_METRICS:
      return {
        ...state,
        viewMetrics: action.value,
        isLoading: false,
      }
    case ActionType.SET_USER_REACTION_METRICS:
      return {
        ...state,
        userReactionMetrics: action.value,
        isLoading: false,
      }
    case ActionType.SET_TEXT_TO_SPEECH_METRICS:
      return {
        ...state,
        textToSpeechMetrics: action.value,
        isLoading: false,
      }
    default:
      return state
  }
}

export default function useMetrics(id) {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { formatMessage } = useIntl()

  const commonDispatch = useDispatch()

  const handleAlertError = (error) => {
    dispatch({
      type: ActionType.SET_LOADING,
      value: false,
    })
    return commonDispatch(MessageAlert.showNetworkError(formatMessage)(error))
  }

  const fetchDeliverMetrics = () => {
    effects.apis
      .getNotificationTimelineMetrics({
        timeLineId: id,
        metricsType: DELIVER,
      })
      .then((res) => {
        dispatch({
          type: 'SET_DELIVER_METRICS',
          value: res,
        })
      })
      .catch((error) => handleAlertError(error))
  }

  const fetchViewMetrics = () => {
    effects.apis
      .getNotificationTimelineMetrics({
        timeLineId: id,
        metricsType: READ,
      })
      .then((res) => {
        dispatch({
          type: 'SET_VIEW_METRICS',
          value: res,
        })
      })
      .catch((error) => handleAlertError(error))
  }

  const fetchUserReactionMetrics = () => {
    effects.apis
      .getNotificationTimelineMetrics({
        timeLineId: id,
        metricsType: REACTION,
      })
      .then((res) => {
        dispatch({
          type: 'SET_USER_REACTION_METRICS',
          value: res,
        })
      })
      .catch((error) => handleAlertError(error))
  }

  const fetchTextToSpeechMetrics = () => {
    effects.apis
      .getNotificationTimelineMetrics({
        timeLineId: id,
        metricsType: TTS,
      })
      .then((res) => {
        dispatch({
          type: 'SET_TEXT_TO_SPEECH_METRICS',
          value: res,
        })
      })
      .catch((error) => handleAlertError(error))
  }

  return {
    state,
    fetchDeliverMetrics,
    fetchViewMetrics,
    fetchUserReactionMetrics,
    fetchTextToSpeechMetrics,
  }
}
